/** sets local storage key and value
 * @param {string} key new local storage key
 * @param {string} value new local storage value
 */
function setLSItem(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
    return value;
}

/**
 * gets local storage value - returns null if key does not exist
 * @param {object} key local storage key
 */
function getLSItem(key) {
    if (!localStorage.getItem(key)) return null;
    return JSON.parse(localStorage.getItem(key));
}

/**
 * gets service preferences from local storage
 * @param {object} service the type of service object preference to return (intercom, google_tag_manager ...)
 */
function getLSPrivacyServices(service) {
    const services = getLSItem("privacy-services");

    if (!services) return null;

    // return specific service preference
    const service_found = services.find((x) => x.service === service);
    if (!service_found) return null;

    return service_found;
}

export { getLSItem, setLSItem, getLSPrivacyServices };
